export default {
  name: 'toastwrap',
  props: {
    txt: {
      type: String,
      default: ''
    },
    mb: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};